export const avatarWidth = 20;
